// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1S8Xi","actions":"GroupTable_actions__3tEB3","deleteModalFooter":"GroupTable_deleteModalFooter__t84E4"};